'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

function UIGrid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return React.createElement("div", Object.assign({}, props, {
    className: classNames('row', className)
  }), children);
}

UIGrid.propTypes = {
  children: PropTypes.node.isRequired
};
UIGrid.displayName = 'UIGrid';
export default UIGrid;